/* eslint-disable react/prefer-es6-class, react/prop-types, react/no-multi-comp, react/jsx-no-bind */
import classnames from 'classnames';
import React from 'react';

/**
 * The proper way to stack these is in the format.
 *
 * <Choices onChange={someFunction} value={20}>
 *    <Choice value={5} disabled={true}>5</Choice>
 *    <Choice value={10}>10</Choice>
 *    <Choice value={20}>20</Choice>
 * </Choices>
 */

export const Choice = React.createClass({
  displayName: 'Choice',

  propTypes: {
    onClick: React.PropTypes.func,
    disabled: React.PropTypes.bool,
    value: React.PropTypes.any.isRequired,
    selected: React.PropTypes.bool,
  },

  getDefaultProps() {
    return {
      disabled: false,
      onClick: null,
      selected: false,
    };
  },

  handleClick() {
    if (this.props.onClick && !this.props.disabled) {
      this.props.onClick.call(this, this.props.value);
    }
  },

  render() {
    const { disabled, selected } = this.props;
    const className = classnames('choice', { disabled, selected });

    return (
      <li className={className} onClick={this.handleClick}>{this.props.children}</li>
    );
  },
});

export const Choices = React.createClass({
  displayName: 'Choices',

  propTypes: {
    className: React.PropTypes.string,
    onChange: React.PropTypes.func.isRequired,
    value: React.PropTypes.any,
  },

  getDefaultProps() {
    return {
      className: '',
      value: null,
    };
  },

  render() {
    const className = `choice-set ${this.props.className}`;
    const { children, onChange, value } = this.props;

    /**
     * Take the child properties and create a new set of properties
     * for rendering the choices.
     */
    const choices = React.Children.map(children, (child, i) => {
      const props = Object.assign({}, child.props, {
        key: i,
        onClick: onChange.bind(null, child.props.value),
        selected: child.props.value === value,
      });

      return (<Choice {...props} />);
    });

    return (
      <ul className={className}>{choices}</ul>
    );
  },
});
